module.exports = __webpack_public_path__ + "img/step3.a0c5588e.svg";